module.exports = __webpack_public_path__ + "static/img/glove_clematite.ba529f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_clematite.png
// module id = OumC
// module chunks = 0